import { instance } from "../../_axios"

export default class Schedule{
    static fetch(){
        return instance.get('/live-class?ts='+Date.now())
    }
    static days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
}